var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('page-header'),(_vm.isAuthenticated)?_c('site-menu'):_vm._e(),_c('div',{staticClass:"content-container container"},[_c('router-view')],1),_c('site-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }